export default {
  wbl: {
    category: "WBLCategory 목록",
    create: "흰색 검정색 목록 만들기",
    id: "Id",
    list: "WBL 목록",
    title: "화이트 / 블랙리스트",
    update: "화이트 블랙리스트 업데이트",
    value_list: "값 목록",
    wbl_category: "화이트 / 블랙리스트 카테고리",
  },
}